module.exports = __webpack_public_path__ + "img/nebula.917bf4f1.png";